import { useState, useEffect, forwardRef, } from 'react'
import { Grid, Typography, Card, CardContent, Button, CircularProgress, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Slide, IconButton } from '@mui/material';
import { toast } from 'react-toastify';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getCurrentDate } from "../functions/current";
import config from '../config.json';
import { apiRequest } from '../functions/apiRequest';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const statusColors = {
    'pending': '#8d4004',
    'accepted': '#378805',
    'completed': '#378805',
    'rejected': '#b53737'
}


export default function HumanLibraryRequests({ isMobile, localUserData }) {

    const displayFontSize = isMobile ? 18 : 20;
    const [index, selectedIndex] = useState(0);
    const [allRequests, setAllRequests] = useState({ requestee: [], requester: [] });
    const [requests, setRequests] = useState({ type: "received", data: [] });
    const [loading, setLoading] = useState(false);
    const [time, setTime] = useState('18:00');
    const [date, setDate] = useState('');
    const [submitHit, setSubmitHit] = useState(false);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const [select, setSelect] = useState({
        btn1: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
        btn2: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor1,
    });

    const sentToMe = () => {
        setSelect({
            btn1: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor1,
            btn2: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
        });
        setRequests({ type: "sent", data: allRequests.requester })
    }

    const receivedByMe = () => {
        setSelect({
            btn1: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor2,
            btn2: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor1,
        });
        setRequests({ type: "received", data: allRequests.requestee })
    }

    const rejectRequest = async (idx) => {
        let endPoint = `/api/humanlibrary/reject/request/${allRequests.requestee[idx].id}`

        try {

            let res = await fetch(process.env.REACT_APP_API_URL + endPoint, {
                method: "POST",
                body: JSON.stringify({ userID: localUserData.id }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${localUserData.token}`,
                },
            })
            let data = await res.json()
            console.log(data)
            toast.success('Request Rejected')


        } catch (err) {

            toast.error(err.message);

        }

    }

    async function fetchData() {
        try {
            const data = await apiRequest('get', null, `/humanlibrary/get/request/${localUserData.id}`, localUserData.token);
            setAllRequests(data)
            setRequests({ type: "received", data: data.requestee })
        } catch (err) {
            toast.error(err.message);
        }
    }

    const handleConfirmation = async (id) => {
        try {
            const response = await apiRequest('POST', null, `/humanlibrary/confirm/request/${id}`, localUserData.token, null, null, true);
            if (!response.data.error) {
                toast.success(response.data.message)
                fetchData();
                receivedByMe();
            } else {
                toast.error(response.data.error)
            }
        } catch (err) {
            console.log(err);
        }
    }

    const handleAccept = async () => {

        if (!date || !time) {
            setSubmitHit(true)
            return;
        }

        setLoading(true)

        let endPoint = `/api/humanlibrary/accept/request/${allRequests.requestee[index].id}`

        try {

            let res = await fetch(process.env.REACT_APP_API_URL + endPoint, {
                method: "POST",
                body: JSON.stringify({
                    userID: localUserData.id,
                    "meetDate": date,
                    "meetTime": time,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Token ${localUserData.token}`,
                },
            })
            let data = await res.json()
            console.log(data)
            if (data.error) {
                toast.error(data.error)
            } else {
                toast.success('Request Accepted')
            }

            setLoading(false)
            setSubmitHit(false)
            handleClose();
            fetchData();

        } catch (err) {
            setLoading(false)
            setSubmitHit(false)
            handleClose()
            toast.error(err.message);

        }
    }

    const requestTypeMapping = {
        sent: {
            direction: 'sent to',
            key_name: 'requestee_name'
        },
        received: {
            direction: 'received from',
            key_name: 'requester_name'
        }
    }

    const DisplayRequests = ({ request, idx, type }) => {
        return (
            <Card
                variant='outlined'
                style={{
                    borderRadius: 30,
                    marginTop: displayFontSize,
                    outlineColor: 'black',
                }}
            >
                <CardContent style={{ fontFamily: 'Raleway' }}>
                    <Grid container>
                        <Grid item xs={12} sm={12} md={9}>
                            <Grid container>
                                <Grid item xs={11} md={11}>
                                    <Typography
                                        component='h1'
                                        style={{
                                            fontSize: 25,
                                            fontFamily: 'Raleway',
                                        }}
                                    >
                                        Request {requestTypeMapping[type].direction} <strong>{request[requestTypeMapping[type].key_name]}</strong>
                                    </Typography>
                                </Grid>
                                {request.linkedin_url && <Grid item xs={1} md={1}>
                                    <Typography
                                        component='h1'
                                        style={{
                                            paddingTop: '4px',
                                            fontSize: 22,
                                            fontFamily: 'Raleway',
                                        }}
                                    >
                                        <a href={request.linkedin_url} rel="noreferrer" target="_blank" > <LinkedInIcon color="primary" /></a>
                                    </Typography>
                                </Grid>
                                }
                                {request.interaction_status === 'accepted' &&
                                    <Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography
                                                component='h5'
                                                style={{
                                                    fontSize: displayFontSize,
                                                    color: 'black',
                                                    fontFamily: 'Raleway',
                                                    paddingTop: '2vh'
                                                }}
                                            >
                                                Meeting Time : <strong>{request.meet_time}</strong>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Typography
                                                component='h5'
                                                style={{
                                                    fontSize: displayFontSize,
                                                    color: 'black',
                                                    fontFamily: 'Raleway',
                                                }}
                                            >
                                                Meeting Date : <strong>{request.meet_date}</strong>
                                            </Typography>
                                        </Grid>
                                    </Grid>}
                                <Grid item xs={12}>
                                    <Typography
                                        component='h5'
                                        style={{
                                            fontSize: displayFontSize,
                                            color: 'black',
                                            fontFamily: 'Raleway',
                                            paddingTop: '2vh'
                                        }}
                                    >
                                        Requested Hours : <strong>{request.hours_requested}</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography
                                        component='h5'
                                        style={{
                                            fontSize: displayFontSize,
                                            color: 'black',
                                            fontFamily: 'Raleway',
                                        }}
                                    >
                                        Subject : <strong>{request.subject}</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography
                                        component='h5'
                                        style={{
                                            fontSize: displayFontSize,
                                            color: 'black',
                                            fontFamily: 'Raleway',
                                        }}
                                    >
                                        Requested Meeting Location : <strong>{request.meeting_location}</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography
                                        component='h5'
                                        style={{
                                            fontSize: displayFontSize,
                                            color: 'black',
                                            fontFamily: 'Raleway',
                                        }}
                                    >
                                        Prefered Days : <strong>{request.prefered_days.join(', ')}</strong>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography
                                        component='h5'
                                        style={{
                                            fontSize: displayFontSize,
                                            color: 'black',
                                            fontFamily: 'Raleway',
                                        }}
                                    >
                                        Prefered Hours : <strong>{request.prefered_hours_start} - {request.prefered_hours_end}</strong>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} >
                            <Grid container spacing={1}>
                                <Grid item md={12} xs={6}>
                                    <div >
                                        <img alt={'requester'} src={request.requester_pic} width='100%' />
                                    </div>
                                </Grid>
                                <Grid item md={12} xs={6} >
                                    <Typography
                                        component='h5'
                                        style={{
                                            color: statusColors[request.interaction_status],
                                            fontSize: displayFontSize,
                                            fontFamily: 'Raleway',
                                            justifyContent: 'center', display: 'flex'
                                        }}
                                    >
                                        <strong>{request.interaction_status.slice(0, 1).toUpperCase() + request.interaction_status.slice(1, request.interaction_status.length)}</strong>
                                    </Typography>
                                    {(request.past_meet_time && ((requests.type === 'sent' && !request.requester_confirmation) || (requests.type === 'received' && !request.requestee_confirmation))) &&
                                        <Grid item xs={12} md={12} >
                                            Was the time exchange completed?
                                            <IconButton
                                                style={{ color: 'green' }}
                                                onClick={() => handleConfirmation(request.id)}
                                                size="large">
                                                <CheckCircleIcon />
                                            </IconButton>
                                            {/* <IconButton style={{ color: 'red' }}>
                                                <CancelIcon />
                                            </IconButton> */}
                                        </Grid>
                                    }

                                    {(request.past_meet_time && ((requests.type === 'sent' && !request.requestee_confirmation) || (requests.type === 'received' && !request.requester_confirmation))) &&
                                        <Grid item xs={12} md={12} >
                                            Waiting for confirmation from {requests.type === 'sent' ? request.requestee_name : request.requester_name}
                                            <br />
                                            <br />
                                            {/* <IconButton style={{ color: 'red' }}>
                                                <CancelIcon />
                                            </IconButton> */}
                                        </Grid>
                                    }
                                    {['accepted', 'completed'].includes(request.interaction_status) &&
                                        <div>
                                            <Grid item md={12} xs={12} >
                                                <Button
                                                    fullWidth
                                                    onClick={() => window.location = `/event/${request.event}`}
                                                    style={{
                                                        fontFamily: 'Raleway',
                                                        backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                                        borderRadius: 30,
                                                        color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                                                    }}
                                                >
                                                    View Event
                                                </Button>
                                            </Grid>
                                        </div>}
                                    {request.interaction_status === 'pending' && parseInt(request.requestee) === parseInt(localUserData.id) &&
                                        <div>
                                            <Grid item md={12} xs={12} >
                                                <Button
                                                    onClick={() => rejectRequest(idx)}
                                                    fullWidth
                                                    style={{
                                                        height: 40,
                                                        fontFamily: 'Raleway',
                                                        backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                                        borderRadius: 30,
                                                        color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                                                    }}
                                                >
                                                    Reject
                                                </Button>
                                            </Grid>
                                            <Grid item md={12} xs={12} >
                                                <div style={{ paddingTop: 5, }}>
                                                    <Button
                                                        fullWidth
                                                        onClick={() => { setOpen(true); selectedIndex(idx) }}
                                                        style={{
                                                            height: 40,
                                                            fontFamily: 'Raleway',
                                                            backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                                            borderRadius: 30,
                                                            color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                                                        }}
                                                    >
                                                        Accept
                                                    </Button>
                                                </div>
                                            </Grid>
                                        </div>}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );

    }

    useEffect(() => {
        fetchData();

        // eslint-disable-next-line
    }, [])

    return (
        <div style={{ padding: '25px' }}>
            <div style={{ padding: '25px', display: 'flex', justifyContent: 'center', fontSize: '50px', fontWeight: 'normal' }}>
                Human Library Requests
            </div>
            <Grid container spacing={1} direction='column' alignItems='center'>
                <Grid item xs={6} md={6}>
                    <Button
                        style={{
                            height: 40,
                            textTransform: "none",
                            color: "#ffffff",
                            fontSize: 16,
                            backgroundColor: `${select.btn1}`,
                            borderRadius: 100,
                            fontFamily: "Raleway",
                        }}
                        onClick={sentToMe}
                    >
                        Sent Requests
                    </Button>
                </Grid>
                <Grid item xs={6} md={6}>
                    <Button
                        style={{
                            height: 40,
                            textTransform: "none",
                            color: "#ffffff",
                            fontSize: 16,
                            backgroundColor: `${select.btn2}`,
                            borderRadius: 50,
                            fontFamily: "Raleway",
                        }}
                        onClick={receivedByMe}
                    >
                        Received Requests
                    </Button>
                </Grid>
            </Grid>
            <div style={{ boxShadow: '2px 2px 2px black' }}>
                <Dialog
                    open={open}
                    TransitionComponent={Transition}
                    style={{ width: '100vw' }}
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    onClose={handleClose} aria-labelledby="simple-dialog-title"
                >
                    <DialogTitle>Accept request from {allRequests.requestee[index]?.requester_name}?
                    </DialogTitle>
                    <DialogContent>
                        <Grid item xs={12}>
                            <Typography
                                component='h5'
                                style={{
                                    fontSize: displayFontSize,
                                    color: 'black',
                                    fontFamily: 'Raleway',
                                    paddingTop: '1vh'
                                }}
                            >
                                Subject  : <strong>{allRequests.requestee[index]?.subject}</strong>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                component='h5'
                                style={{
                                    fontSize: displayFontSize,
                                    color: 'black',
                                    fontFamily: 'Raleway',
                                    paddingTop: '1vh'
                                }}
                            >
                                Requested Hours  : <strong>{allRequests.requestee[index]?.hours_requested}</strong>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                component='h5'
                                style={{
                                    fontSize: displayFontSize,
                                    color: 'black',
                                    fontFamily: 'Raleway',
                                    paddingTop: '1vh'
                                }}
                            >
                                Meeting Location  : <strong>{allRequests.requestee[index]?.meeting_location}</strong>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                component='h5'
                                style={{
                                    fontSize: displayFontSize,
                                    color: 'black',
                                    fontFamily: 'Raleway',
                                    paddingTop: '1vh'
                                }}
                            >
                                Prefered Hours : From <strong>{allRequests.requestee[index]?.prefered_hours_start}</strong> To <strong>{allRequests.requestee[index]?.prefered_hours_end}</strong>
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                component='h5'
                                style={{
                                    fontSize: displayFontSize,
                                    color: 'black',
                                    fontFamily: 'Raleway',
                                    paddingTop: '1vh'
                                }}
                            >
                                Prefered Days : <strong>{allRequests.requestee[index]?.prefered_days.join(', ')}</strong>
                            </Typography>
                        </Grid>
                        <Grid container spacing={2} style={{ paddingTop: '1vh' }}>
                            <Grid item xs={7} md={6}>
                                <Typography
                                    component='h5'
                                    style={{
                                        fontSize: displayFontSize,
                                        color: 'black',
                                        fontFamily: 'Raleway'
                                    }}
                                >
                                    Set a Date
                                </Typography>
                            </Grid>
                            <Grid item xs={5} md={6}>
                                <Typography
                                    component='h5'
                                    style={{
                                        fontSize: displayFontSize,
                                        color: 'black',
                                        fontFamily: 'Raleway'
                                    }}
                                >
                                    Set a Time
                                </Typography>
                            </Grid>
                            <Grid item xs={7} md={6}>
                                <TextField
                                    id="date"
                                    name="date"
                                    type="date"
                                    size="small"
                                    variant="outlined"
                                    onChange={(e) => { setDate(e.target.value) }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    error={(submitHit && date.length === 0)}
                                    inputProps={{ min: getCurrentDate() }}
                                />
                            </Grid>
                            <Grid item xs={5} md={6}>
                                <TextField
                                    fullWidth
                                    id="time"
                                    type="time"
                                    defaultValue={time}
                                    // InputLabelProps={{
                                    //     shrink: true,
                                    // }}
                                    inputProps={{
                                        step: 900, // 5 min
                                    }}
                                    error={submitHit && time.length === 0}
                                    value={time}
                                    onChange={(e) => { setTime(e.target.value) }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleClose}
                            disabled={loading}
                            style={{
                                height: 40,
                                fontFamily: 'Raleway',
                                width: '6vw',

                                backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                borderRadius: 30,
                                color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleAccept}
                            disabled={loading}
                            style={{
                                height: 40,
                                fontFamily: 'Raleway',
                                width: '6vw',

                                backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                                borderRadius: 30,
                                color: config[process.env.REACT_APP_HOST_NAME].css.buttonFontColor,
                            }}
                        >
                            Submit
                        </Button>
                        <div hidden={!loading}>
                            <CircularProgress color="inherit" />
                        </div>

                    </DialogActions>
                </Dialog>
            </div>
            <Grid container justifyContent='center' >
                <Grid item xs={12} md={8}>
                    {requests.data.length > 0 && requests.data.map((request, idx) => (
                        <DisplayRequests request={request} idx={idx} key={idx} type={requests.type} />
                    ))}
                </Grid>
            </Grid>
        </div >

    )

}